export enum FileType {
  Assessment = 1,
  Review = 2,
  Implementation = 3,
  Interpretation = 4,
  DataJudgement = 5,
  ComplianceGaps = 6,
  Enhancement = 7,
  AssesmentScheduler = 8,
  Policy = 9,
  Response = 10,
  ExternalStackholder = 11,
  InternalStackholder = 12,
  EngagementPlan = 13,
  AssessmentT6=14,
  ReviewT6 =15,
  ImplementationT6=16
}
export enum FileTypeT3 {
  OverAll = 1,

  Review = 2,
  Action = 3,
  Interpretation = 4,

  InterpretationReview = 5,
  IntrepretationApprovals = 6,
  InterpretationAction = 7,
  JudgementAssessment = 8,
  JudgementReview = 9,
  JudgementApprovals = 10,
  JudgementAction = 11,

  ApproachAssessment = 12,
  ApproachReview = 13,
  ApproachApprovals = 14,
  ApproachAction = 15,
}

